<template>
  <div class="registros-container">
    <h2 class="page-title">Cadastrar Novo Funcionário</h2>

    <div class="filtro-container">
      <button @click="goBack" class="btn-principal">
        <i class="fas fa-arrow-left"></i> Voltar
      </button>
    </div>

    <div class="form-card">
      <form @submit.prevent="cadastrarFuncionario">
        <div class="form-row">
          <label>Nome</label>
          <input type="text" v-model="form.nome" required />
        </div>

        <div class="form-row">
          <label>CPF</label>
          <input type="text" v-model="form.cpf" required />
        </div>

        <div class="form-row">
          <label>Data de admissão</label>
          <input type="date" v-model="form.data_admissao" required />
        </div>

        <div class="form-row">
          <label>Email</label>
          <input type="email" v-model="form.email" required />
        </div>

        <div class="form-row">
          <label>Vínculo</label>
          <input type="text" v-model="form.vinculo" />
        </div>

        <div class="form-row">
          <label>Cargo</label>
          <input type="text" v-model="form.cargo" />
        </div>

        <div class="form-row-inline small-fields">
          <div class="form-row-inline-item">
            <label>CBO</label>
            <input type="number" v-model.number="form.cbo" />
          </div>
          <div class="form-row-inline-item">
            <label>Carga horária mês (h)</label>
            <input type="number" step="0.01" v-model.number="form.carga_horaria_mes" />
          </div>
          <div class="form-row-inline-item">
            <label>Carga horária semanal (h)</label>
            <input type="number" step="0.01" v-model.number="form.carga_horaria_semanal" />
          </div>
        </div>

        <div class="form-row">
          <label>Salário</label>
          <input type="number" step="0.01" v-model.number="form.salario" />
        </div>

        <div class="form-row-inline">
          <label>
            <input type="checkbox" v-model="form.is_admin" />
            Administrador
          </label>
        </div>

        <p class="nota-senha">
          Será gerada uma senha padrão inicial <strong>mudar@123</strong>. No primeiro acesso o usuário deverá definir uma senha definitiva.
        </p>

        <div class="form-actions">
          <button type="button" @click="goBack" class="btn-principal btn-outline">Cancelar</button>
          <button type="submit" class="btn-principal" :disabled="loading">
            <span v-if="loading">Salvando...</span>
            <span v-else><i class="fas fa-save"></i> Cadastrar</span>
          </button>
        </div>
      </form>

      <div v-if="message" :class="['message', success ? 'success' : 'error']">
        {{ message }}
      </div>
    </div>
  </div>
</template>

<script>
import { adminService } from '@/services/adminService' // ajuste se necessário

export default {
  name: 'AdminEmployeeCreate',
  data() {
    return {
      loading: false,
      success: false,
      message: '',
      form: {
        nome: '',
        cpf: '',
        data_admissao: '',
        vinculo: '',
        cbo: null,
        cargo: '',
        carga_horaria_mes: null,
        carga_horaria_semanal: null,
        email: '',
        salario: null,
        is_admin: false
      }
    }
  },
  methods: {
    goBack() {
      this.$router.back()
      // ou: this.$router.push({ name: 'AdminEmployees' })
    },

    async cadastrarFuncionario() {
      // validação simples
      if (!this.form.nome || !this.form.email || !this.form.cpf || !this.form.data_admissao) {
        this.message = 'Preencha nome, email, CPF e data de admissão.'
        this.success = false
        return
      }

      this.loading = true
      this.message = ''
      try {
        const payload = {
          nome: this.form.nome,
          cpf: this.form.cpf,
          data_admissao: this.form.data_admissao ? new Date(this.form.data_admissao).toISOString() : null,
          vinculo: this.form.vinculo || null,
          cbo: this.form.cbo || null,
          cargo: this.form.cargo || null,
          carga_horaria_mes: this.form.carga_horaria_mes || null,
          carga_horaria_semanal: this.form.carga_horaria_semanal || null,
          email: this.form.email,
          is_admin: this.form.is_admin ? 1 : 0, // ajuste conforme backend espera (0/1 ou boolean)
          salario: this.form.salario || null
        }

        await adminService.createFuncionario(payload)

        this.success = true
        this.message = 'Funcionário criado com sucesso!'
        // navegar de volta para a lista após criar
        setTimeout(() => {
          this.$router.push({ name: 'FuncionariosList' })
        }, 600)
      } catch (err) {
        console.error('Erro ao cadastrar funcionário:', err)
        this.success = false
        this.message = err.response?.data?.detail || 'Erro ao cadastrar funcionário'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.registros-container { padding: 2rem; }
.page-title { text-align: center; color: #1e293b; margin-bottom: 1.5rem; }

.filtro-container { display: flex; justify-content: center; gap: 0.5rem; margin-bottom: 1rem; }

.btn-principal {
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.6rem 1rem;
  cursor: pointer;
  transition: 0.2s;
}
.btn-principal:hover { background-color: #2563eb; }

.btn-outline {
  background-color: transparent;
  color: #3b82f6;
  border: 1px solid #cbd5e1;
}

.form-card {
  max-width: 640px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 1px 3px rgba(0,0,0,0.08);
}

.form-row {
  display:flex;
  flex-direction:column;
  margin-bottom: 1rem;
}
.form-row label { font-weight:600; color:#475569; margin-bottom:0.5rem; }
.form-row input { padding:0.6rem 0.75rem; border-radius:6px; border:1px solid #e2e8f0; }

.form-row-inline {
  display:flex;
  align-items:flex-start;
  gap:1rem;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}
.form-row-inline.small-fields .form-row-inline-item {
  flex: 1;
  min-width: 140px;
  max-width: 200px;
}
.form-row-inline-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  min-width: 200px;
}
.form-row-inline label { font-weight:500; color:#475569; display:flex; align-items:center; gap:0.4rem; }
.form-row-inline-item label { font-weight:600; color:#475569; }
.form-row-inline-item input {
  padding:0.6rem 0.75rem;
  border-radius:6px;
  border:1px solid #e2e8f0;
  width: 100%;
  }

.form-actions {
  display:flex;
  justify-content:flex-end;
  gap: 0.75rem;
  margin-top: 0.75rem;
}

.message { margin-top: 1rem; padding: 0.75rem; border-radius: 6px; text-align: center; }
.message.success { background-color: #d1fae5; color: #065f46; }
.message.error { background-color: #fee2e2; color: #b91c1c; }

.nota-senha {
  font-size: 0.9rem;
  color: #475569;
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  padding: 0.75rem;
  border-radius: 8px;
}
</style>
